module.exports = __webpack_public_path__ + "合作5.png?32fd6d128a46f59eea807fbd94ea7732";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作5.png
// module id = 647
// module chunks = 0